angular.module('mtic').filter('wsTime', function($filter){
  return function(list, filter){
    return $filter("filter")(list, function(item){
      let start = moment(item.timeStarted);
      let end = moment(item.timeEnded);
      let now = moment();

      if(filter.id === 'all'){
        return true;
      }
      if(filter.id === 'today'){
        return now.diff(end, 'days') === 0;
      }
      if(filter.id === '1week'){
        return now.diff(end, 'weeks') === 0;
      }
      if(filter.id === '2weeks'){
        return now.diff(end, 'weeks') <= 1;
      }
      if(filter.id === '1month'){
        return now.diff(end, 'months') === 0;
      }
    })
  };
});
